/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

//react imports
import React from 'react';

//react native imports
import { type DimensionValue, Platform, View } from 'react-native';

//phoenix imports
import ContentStateView from '@airasia-phoenix/react-native/widgets/ContentStateView';
import {
  ButtonViewState,
  ButtonViewType,
} from '@airasia-phoenix/react-native/components/ButtonView';

//ReactNativeErrorBoundary imports
import FallbackComponentProps from './fallbackComponent.types';
import Labels from '../../labels';
import Constants from '../../constants';
import { resolveImageSource } from '../../utils';

import { StyleSheet } from 'react-native-unistyles';

const FallbackComponent = (props: FallbackComponentProps) => {
  const imageSource = resolveImageSource(require('../../assets/error.png'));
  return (
    <View style={styles.container}>
      <ContentStateView
        imageViewProps={{
          height: Constants.IMAGE_HEIGHT,
          width: Constants.IMAGE_WIDTH,
          source: imageSource,
        }}
        primaryText={
          Labels[props.locale]?.PRIMARY_TEXT ?? Labels['en-gb'].PRIMARY_TEXT
          //fallback to english if invalid locale passed say abc
        }
        secondaryText={
          Labels[props.locale]?.SECONDARY_TEXT ?? Labels['en-gb'].SECONDARY_TEXT
        }
        buttonViewProps={{
          buttonViewState: ButtonViewState.LOADED,
          type: ButtonViewType.SECONDARY_SMALL,
          disabled: false,
          text:
            props.retryLabel ??
            (props.buttonLabel && Labels[props.locale]?.[props.buttonLabel]) ??
            Labels['en-gb'].BUTTON_RETRY_TEXT,
          onPress: props.onButtonPress,
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create((pd) => ({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    minHeight: (Platform.OS === 'web' ? '100vh' : '100%') as DimensionValue,
    backgroundColor: pd.sys.colour.container_none.toString(),
  },
}));

export default FallbackComponent;
